import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { LearnerInfo } from '../../types';
import { useAuth } from '../../utils/hooks';

interface LoginPageProps {
  userInfo: LearnerInfo;
  userLoading: boolean;
}

const LoginPage: FC<LoginPageProps> = ({ userInfo, userLoading }) => {
  const history = useHistory();
  const { loginWithRedirect } = useAuth();

  if (!userLoading && userInfo) {
    history.replace('/home');
  } else {
    loginWithRedirect({
      redirectUri: '/home',
    });
  }

  return null;
};

export default LoginPage;
